import { Suspense, useEffect } from "react";
import type { MouseEvent } from "react";
import styles from "./PostLogin.module.scss";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./components/Sidebar/Sidebar";
import Topbar from "./components/Topbar/Topbar";
import { useDispatch, useSelector } from "react-redux";
import { setSidebarOpen } from "@/store/slices/globalSlice";
import type { RootState } from "@/store/rootReducer";
import ErrorBoundary from "@/components/ErrorBoundary/ErrorBoundary";
import Loader from "@/components/Loader/Loader";
import { getPageTitle } from "@/lib/pageTitle";
import MobileBottomNav from "@/components/MobileBottomNav/MobileBottomNav";

const PostLogin = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const titleName = getPageTitle(location.pathname);
  const sidebarOpen = useSelector((state: RootState) => state.global.sidebarOpen);
  const pageSubtitle = useSelector((state: RootState) => state.global.pageSubtitle);
  const pageTitleOverride = useSelector((state: RootState) => state.global.pageTitle);
  const resolvedTitle = pageTitleOverride || titleName;

  const toggleSidebarOpen = (flag: boolean) => (e: MouseEvent) => {
    e.stopPropagation();
    if (sidebarOpen !== flag) {
      dispatch(setSidebarOpen(flag));
    }
  };

  useEffect(() => {
  const handleResize = () => {
    const isMobile = window.innerWidth < 500;

    dispatch(setSidebarOpen(!isMobile));
  };

  handleResize();

  window.addEventListener("resize", handleResize);

  return () => {
    window.removeEventListener("resize", handleResize);
  };
}, [dispatch]);
  return (
    <div className={styles.rootContainer}>
      <div className={styles.layout}>
        <Sidebar toggleSidebarOpen={toggleSidebarOpen} />

        <div className={styles.rightSideContainer}>
          <Topbar title={resolvedTitle} subtitle={pageSubtitle} />

          <div className={styles.outletDiv}>
            <Suspense fallback={<Loader />}>
              <ErrorBoundary>
                <Outlet context={{ titleName: resolvedTitle }} />
              </ErrorBoundary>
            </Suspense>
          </div>
        </div>
      </div>
      <MobileBottomNav />
    </div>
  );
};

export default PostLogin;
